import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { servicios_grupogack_nomina, calculo_ } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import DataTableService from '../../../DataTableService/DataTableService';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';

const Calculo = ({ id, permisos }) => {

    const [nominas, setNominas] = useState(null);

    useEffect(() => {
        axios.get(`${servicios_grupogack_nomina}/config/nomina`, headersAuth())
        .then(res => {
            switch(res.data.status) {
                case 200:
                    setNominas(res.data.dataResponse);
                    break;
                case 404:
                    setNominas([]);
                    break;
                default:
                    setNominas([]);
                    alert('error');
                    break;
            }
        })
        .catch(error => { setNominas([]); alert('error') });
    },[]);

    return (
        <div id={id}>
            {   
                (nominas)
                ?   <DataTableService id={id} title={ calculo_ }
                        columns={[
                            { field: "nominaClave", title: "Clave" },
                            { field: "nominaNomCorto", title: "Nombre Corto" },
                            { field: "nominaNombre", title: "Nombre Nómina" },
                            { field: "nominaDescrip", title: "Descripción" },
                        ]}
                        data={nominas}
                        permisos={permisos}
                        informacionAdicional={{ permisos }}
                        hideIconAdd hideIconEdit hideIconDelete showIconPayment
                    />
                :   <SpinnerOval />
            }
        </div>
    );
}
 
export default Calculo;
